// extracted by mini-css-extract-plugin
export var bigHeading = "f6_mX";
export var container = "f6_f";
export var details = "f6_mZ";
export var highlight = "f6_kx";
export var smallHeading = "f6_mY";